import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { ELanguage } from '../../../types/enums/ELanguage'

export const HamburgerMenuWrapper = styled.div<{
  languagesCode: ELanguage
}>`
  position: absolute;
  display: flex;
  justify-content: end;
  top: 20px;
  left: ${({ languagesCode }) =>
    languagesCode === ELanguage.HEBREW ? '20px' : 'unset'};
  right: ${({ languagesCode }) =>
    languagesCode === ELanguage.HEBREW ? 'unset' : '20px'};
  z-index: 1;
  font-family: ${({ theme }) => theme.fonts.inter}, sans-serif;
  cursor: pointer;
`

export const StyledButton = styled.button`
  display: inline-flex;
  padding: 8px;
  align-items: center;
  gap: 8px;
  border-radius: 40px;
  background: #fff;
  border: none;
  color: black;
  cursor: pointer;
`

export const StyledMenuOptions = styled.div<{
  languagesCode: ELanguage
}>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 3px;
  position: absolute;
  left: ${({ languagesCode }) =>
    languagesCode === ELanguage.HEBREW ? '0' : 'unset'};
  right: ${({ languagesCode }) =>
    languagesCode === ELanguage.HEBREW ? 'unset' : '0'};
  top: 60px;
  border-radius: 16px;
  border: 1px solid #f5f5f5;
  background: #fff;
  padding: 24px 20px;
`
export const StyledText = styled.h3`
  display: flex;
  font-size: 16px;
  font-weight: 600;
  text-align: right;
  padding: 0px 8px;
  margin: 0;
`
export const ChosenLanguage = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid #dd1c22;
  background: #dd1c2222;
  padding: 0px 8px;
`

export const OtherLanguages = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  padding: 0px 8px;
`
export const StyledFlagIcon = styled.img`
  display: flex;
  height: 24px;
  width: 24px;
  cursor: pointer;
  border: 0.5px solid black;
  border-radius: 50px;
`
export const StyledFlagText = styled.h4`
  text-align: right;
  font-size: 14px;
  font-weight: 400;
`

export const StyledLink = styled(Link)`
  color: #dd1c22;
  text-decoration: none;
  display: flex;
  gap: 8px;
  margin: 0 auto;
`

export const StyledLogoutIcon = styled.img`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`
export const StyledLinkText = styled.h4`
  color: #dd1c22;
  text-align: right;
  font-size: 14px;
  font-weight: 400;
`
